{
	"title": "Fatture",
	"buttonShowMoreInvoicesTitle": "Mostra più fatture",
	"invoicesTableHeaders": {
		"date": "Date",
		"invoiceNumber": "Numero fattura",
		"deliveredQuantity": "Quantità consegnata",
		"bundledCarbonSavings": "Riduzioni di carbonio raggruppate",
		"transactionId": "ID transazione"
	},
	"errorMessage": "Impossibile caricare le fatture"
}
